import React from 'react';
import i18n from '@/utils/i18n';
import { useGetEventAccountStockQuery } from '../../../../graphql/queries/getEventAccountStock.generated';
import { DepositClearingTable } from './DepositClearingTable';

type DepositClearingEventAccountProps = {
  eventAccountId: string;
  eventId: string;
};

export const DepositClearingEventAccount = ({
  eventAccountId,
  eventId,
}: DepositClearingEventAccountProps) => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [endDate, setEventEndDate] = React.useState<Date | null>(null);

  const { data, error, refetch, loading } = useGetEventAccountStockQuery({
    variables: {
      event_account_id: eventAccountId,
      event_id: eventId,
      start_date: startDate?.toISOString(),
      end_date: endDate?.toISOString(),
    },
    fetchPolicy: 'network-only',
  });

  if (error || (data == null && !loading)) {
    console.log(error);
    return <div>{i18n.t('DepositClearingTable:errorLoading')}</div>;
  }

  if (!data?.getEventAccountStock) {
    return <div>{i18n.t('DepositClearingTable:noData')}</div>;
  }

  return (
    <div>
      <DepositClearingTable
        eventId={eventId}
        data={data?.getEventAccountStock}
        error={error}
        loading={loading}
        refetch={refetch}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEventEndDate={setEventEndDate}
      />
    </div>
  );
};
